import { Right } from "@insightfulscience/shared-utils/either";

export const submitEmail =
	({ email }) =>
	({ trialService }) => {
		return trialService.requestTrial(email).then(Right);
	};
